// extracted by mini-css-extract-plugin
export default {"container":"auth_container__BjiQg","button":"auth_button__2oBxo"};